"use client";

import React from "react";

const IntroSection: React.FC = () => {
  return (
    <div className="w-full py-6 sm:py-8 ">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Why Choose Sealant for Your Teeth?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Ever wondered why some people seem to have perfect teeth? While genetics
          play a role, there&#39;s another secret weapon that can help keep your smile
          healthy and cavity-free: dental sealants. But what exactly are they, and
          how do they work? Let&#39;s explore this simple yet powerful tool for
          maintaining excellent oral health.
        </p>
      </div>
    </div>
  );
};

export default IntroSection;